import React from "react";
import bindActionCreators from "redux/src/bindActionCreators";
import config from "../../../config";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import Slider from "react-slick";
import connect from "react-redux/es/connect/connect";
import _ from "underscore";
import {getVaultItems} from "../../actionCreators/appAC";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {getImageBySizeFromCDN} from "../../common/utils";
import {Button} from "react-bootstrap";

class Homemagazine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    render() {
        const homeslide = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dotsClass: "slick-dots--custom",
            customPaging: (index) => {
                return (
                    <Button
                        variant="clean"
                        className="custom-slick-dot"
                        aria-label={`Slide Page ${index + 1}`}
                    >
                        <span className="custom-slick-dot__inner"/>
                    </Button>
                );
            }
        };
        const mobile = this.state.width < 544;
        const {vault_articles} = this.props;
        const vault_articles_items = vault_articles && vault_articles.items;

        return (
            <div className="h-m-a-s">
                <Row>
                    <Col>
                        <div className="h-m-a">
                            <h2>The Vault</h2>
                            {!mobile &&
                            <div>
                                <CardGroup>
                                    {_.map(_.first(vault_articles_items, 3), (article, idx) => {
                                        return (
                                            <RenderMagazine
                                                key={idx}
                                                article={article}
                                            />
                                        )
                                    })}
                                </CardGroup>
                            </div>
                            }
                            {mobile &&
                            <div>
                                <Slider {...homeslide} className="collection-container-carousel">
                                    {_.map(_.first(vault_articles_items, 3), (article, idx) => {
                                        return (
                                            <RenderMagazine
                                                key={idx}
                                                article={article}
                                            />
                                        )

                                    })}
                                </Slider>
                            </div>
                            }
                            <a href={config.host_rebag_vault} target="_blank" rel="noopener noreferrer">
                                See All Posts <i/>
                            </a>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

const RenderMagazine = ({article}) => {
    return (
        <Card
            as="a"
            href={`${article.url}`}
            className="coll-per"
        >
            <span className="img-container">
                <LazyLoadImage
                    className="card-img"
                    alt={article.title}
                    title={article.title}
                    src={getImageBySizeFromCDN(article.image, "f=auto,q=90,w=433")}
                    srcSet={`${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=1022")} 1022w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=750")} 750w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=511")} 511w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=375")} 375w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=233")} 233w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=298")} 298w,
                            ${getImageBySizeFromCDN(article.image, "f=auto,q=90,w=375")} 375w`}
                    sizes="(max-width: 375px) 375px,
                    (max-width: 544px) 511px,
                    (max-width: 768px) 233px,
                    (max-width: 992px) 298px,
                    375px"
                    width="375"
                    height="496"
                />
            </span>
            <Card.Title as="div">{article.title}</Card.Title>
        </Card>
    )
}
const mapStateToProps = function (state) {
    const {vault_articles} = state.appReducer;
    return {vault_articles};
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getVaultItems
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Homemagazine);
